import { formatDate } from 'src/utils/helpers';
import { formatMoney } from 'src/utils/formatMoney';
import { isSiteCanadian } from 'src/utils/helpers';
import { PaymentInformation } from 'src/services/models/payment.service';
import { Tabs } from '../../make/index';
import { useLocalization } from 'src/utils/useLocalization';
import {
    AccountType,
    BankAccountType,
    PaymentReason,
    PurchaseType,
    SecurityDepositWaiverType,
} from 'src/utils/enums/payment.enum';
import './style.scss';
interface IProps {
    payment: PaymentInformation;
    accountType: string;
    tab: Tabs;
}

const ListItem: React.FC<{ value: any; title: string }> = ({
    value,
    title,
}) => {
    return (
        <div className='field-show'>
            <span className='label'>{title}</span>
            <span className='value'>{value}</span>
        </div>
    );
};

const ViewInformation = ({ payment, accountType, tab }: IProps) => {
    const units = isSiteCanadian() ? '(km)' : '(miles)';
    const {
        payments,
        paymentReasonEnumToUi,
        paymentBankAccountTypeToUi,
        payoffPaymentInformation,
        assignSecurityDepositToUi,
        purchaseTypeToUi,
    } = useLocalization();
    const pay = payment;
    const amount = {
        value: formatMoney(pay.PaymentAmount),
        title: payments.PAYMENT_INFORMATION_AMOUNTLABEL,
    };
    const dealerRef = {
        value: pay.DealerReferenceId,
        title: payments.PAYMENT_INFORMATION_DEALERREFLABEL,
    };
    const transactionId = {
        value: pay.PaymentTransactionId,
        title: payments.PAYMENT_INFORMATION_TRANSACTION_ID,
    };
    const processDate = {
        value: formatDate(pay.ProcessDateTime),
        title: payments.PAYMENT_INFORMATION_WITHDRAWAL_DATE,
    };

    const fillLeftList = () => {
        if (accountType == AccountType.RetailBalloon && tab === Tabs.PAYOFF) {
            return [
                amount,
                {
                    value: formatMoney(pay.SecurityDeposit || ''),
                    title: payoffPaymentInformation.SECURITY_DEPOSIT,
                },
                {
                    value: assignSecurityDepositToUi[
                        pay.AssignSecurityDeposit as SecurityDepositWaiverType
                    ],
                    title: payoffPaymentInformation.ASSIGN_SECURITY_DEPOSIT_LABEL,
                },
                {
                    value: pay.LpaAdjustment || '',
                    title: payoffPaymentInformation.LPA_LABEL,
                },
                {
                    value: pay.LoyaltyVin || '',
                    title: payoffPaymentInformation.LOYALTY_VIN,
                },
                {
                    value: formatMoney(pay.Total || ''),
                    title: payoffPaymentInformation.TOTAL,
                },
            ];
        } else {
            return [
                amount,
                {
                    value: paymentReasonEnumToUi[
                        pay.SelectedPaymentReason as PaymentReason
                    ],
                    title: payments.PAYMENT_INFORMATION_REASONLABEL,
                },
                {
                    value: paymentBankAccountTypeToUi[
                        pay.BankAccount.BankAccountType as BankAccountType
                    ],
                    title: payments.PAYMENT_INFORMATION_PAIDFROM,
                },
                dealerRef,
            ];
        }
    };

    const fillRightList = () => {
        if (accountType == AccountType.RetailBalloon && tab === Tabs.PAYOFF) {
            return [
                {
                    value: pay.OdometerReading || '',
                    title: `${payoffPaymentInformation.ODOMETER_READING} ${units}`,
                },
                {
                    value: purchaseTypeToUi[pay.PurchaseType as PurchaseType],
                    title: payoffPaymentInformation.PURCHASE_TYPE_LABEL,
                },
                {
                    value: paymentBankAccountTypeToUi[
                        pay.BankAccount.BankAccountType as BankAccountType
                    ],
                    title: payoffPaymentInformation.PAYMENT_TYPE_LABEL,
                },
                dealerRef,
                transactionId,
                processDate,
            ];
        } else {
            return [
                {
                    value: pay.DealerComment,
                    title: payments.PAYMENT_INFORMATION_COMMENT,
                },
                transactionId,
                processDate,
            ];
        }
    };

    const leftList = fillLeftList();
    const rightList = fillRightList();
    return (
        <div className='payment-info'>
            <section className='c-form-section payment-account-info'>
                <div className='c-form-section__content'>
                    <div className='title'>
                        <h6>
                            <span className='c-section-heading__title-text u-mr-xxsmall'>
                                {
                                    payments.PAYMENT_INFORMATION_DETAILS_PAYMENTINFO
                                }
                            </span>
                        </h6>
                    </div>
                    <div className='o-fieldset__row u-mt-small u-mb-small'>
                        <div className='o-layout'>
                            <div className='o-layout__item  u-1/2  u-1/1@l'>
                                {leftList.map((item) => (
                                    <ListItem
                                        value={item.value}
                                        title={item.title}
                                        key={item.title}
                                    />
                                ))}
                            </div>
                            <div className='o-layout__item  u-1/2  u-1/1@l'>
                                {rightList.map((item) => (
                                    <ListItem
                                        value={item.value}
                                        title={item.title}
                                        key={item.title}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ViewInformation;
